import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../app/store";
import { getGamesHistory } from "../features/gameHistory/gameHistorySlice";
import Ball from "./Ball";

const GamesHistory = () => {
  const dispatch = useDispatch();
  const { games } = useSelector((state) => state.gameHistory);

  useEffect(() => {
    dispatch(getGamesHistory());
  }, [dispatch]);

  const tableContent = games?.map((game, index) => {
    const balls = game?.balls || [];
    const visibleBalls = balls.slice(0, 13);
    const hiddenCount = Math.max(balls.length - visibleBalls.length, 0);
    return (
      <tr className="row" key={game?.id || game?.round || index}>
        <td>{game.round}</td>
        <td className="balls">
          {visibleBalls.map((ball, idx) => (
            <Ball key={`${game?.id || game?.round || "ball"}-${ball}-${idx}`} number={ball} />
          ))}
          {hiddenCount > 0 && (
            <span className="balls-hidden">{`+${hiddenCount}`}</span>
          )}
        </td>
      </tr>
    );
  });
  return (
    <table className="history">
      <thead>
        <tr>
          <td style={{ width: "2rem" }}>Round</td>
          <td>Boules</td>
        </tr>
      </thead>
      <tbody>{tableContent}</tbody>
    </table>
  );
};
export default GamesHistory;
